"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const state_1 = __importDefault(require("../state"));
const getTilemap_1 = __importDefault(require("./definables/getTilemap"));
const getMouseCoords = () => (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).getCoordsFromScreenCoords(state_1.default.mouseScreenCoords);
exports.default = getMouseCoords;
